import { HttpEventType, HttpResponse } from '@angular/common/http';
import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AnimationOptions } from 'ngx-lottie';
import { MonitorTaskService } from '../../../../services/monitor-task.service';
import { SwalService } from 'projects/shared/src/services/swal.service';

export interface DialogData {
  taskId: number;
}

@Component({
  selector: 'app-run-ai-process',
  standalone: false,
  templateUrl: './run-ai-process.component.html'
})
export class RunAiProcessComponent implements OnInit {

  progress = 0;
  loading = false;
  options: AnimationOptions | null = {
    path: '/assets/js/analyzing_website.json',
    loop: true,
  };

  constructor(
    public dialogRef: MatDialogRef<RunAiProcessComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private service: MonitorTaskService,
    private swalService: SwalService
  ) { }

  ngOnInit() {
    this.saveRecord();
  }

  saveRecord() {
    this.loading = true;
    this.progress = 0;
    // console.log(this.data)
    this.service.runAi(this.data.taskId).subscribe((res: any) => {
      if (res.type === HttpEventType.UploadProgress) {
        this.progress = Math.round((100 * res.loaded) / res.total);
      } else if (res instanceof HttpResponse) {
        this.progress = 0;
        this.loading = false;
        this.dialogRef.close(res.body);
      }
      // console.log(this.progress)
    }, (err: any) => {
      this.loading = false;
      this.dialogRef.close();
      this.handleErrors(err.detail);
    });
  }

  handleErrors(errors: any) {
    errors = JSON.parse(errors);
    errors.ErrorDTO.forEach((error: any) => {
      this.swalService.swalFailed(error.Error);
    });
  }

}
